export const ACTION_SIZE = ['sm', 'md', 'lg'];
export const ACTION_VARIANT = ['filled', 'tonal', 'outline', 'flat'];
export const ACTION_STATE = ['enabled', 'disabled', 'loading', 'readonly'];